import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export interface PhaseSetting {
  id: string;
  phase_key: string;
  phase_title: string;
  display_order: number | null;
  notes: string | null;
  default_product_id: string | null;
  created_at: string;
  updated_at: string;
}

export function usePhaseSettings() {
  return useQuery({
    queryKey: ['phase-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('installation_phase_settings')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data as PhaseSetting[];
    },
  });
}


export function useUpdatePhaseDefaultProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      default_product_id,
    }: {
      id: string;
      default_product_id: string | null;
    }) => {
      const { data, error } = await supabase
        .from('installation_phase_settings')
        .update({ default_product_id })
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['phase-settings'] });
      toast.success('Default product updated');
    },
    onError: (error) => {
      toast.error('Failed to update default product', {
        description: error.message,
      });
    },
  });
}

